var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"percentage-container"},[_c('div',{staticClass:"the-percentage",style:({ background: _vm.bgColor })},[_c('div',{staticClass:"percent",style:({
                width: _vm.deltaWidthPercent + '%',
                background: _vm.color,
                left: _vm.deltaPositionRelative + '%',
            })})]),_c('div',{class:['average', { last: _vm.last }],style:(`left: calc(${_vm.middlePercent}% - 2px)`)}),(_vm.showlabel)?_c('span',{staticClass:"average-label",style:(`left: calc(${_vm.middlePercent}% - 26px)`)},[_vm._v(_vm._s(_vm.averageText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }